module.exports = __webpack_public_path__ + "static/media/02-home2.512babb8.png";